import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { loadingModal } from "src/redux-app";
import { useEstadosApis } from "../hooks/useEstadosApis";
import { EstadoApi } from "../../bussines/entities/EstadoApi.entity";
import { CopyInfo } from "../components/CopyInfo";
import { format } from "date-fns";
import { TablaScreen } from "../components/TablaScreen";
import { CircularProgress, Grid, Typography } from "@mui/material";
import { MuiDataTable } from "../components/Tabla";

// Columnas de la tabla
const columns = [
    {
        name: '',
        label: '#',
        options: {
            filter: false,
            display: 'true',
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                const rowIndex = tableMeta.rowIndex + 1;
                return rowIndex;
            }
        }
    },
    {
        name: 'modulo',
        label: 'Modulo',
        options: {
            filter: true,
            display: 'true',
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                let time = tableMeta.rowData[3];
                if (typeof time === 'string') {
                    time = parseFloat(time.replace(/[^\d.-]/g, ''));
                }
                return codeWithButtonCopy(value, tableMeta.rowData[4], time);
            }
        }
    },
    {
        name: 'path',
        label: 'Path',
        options: {
            filter: true,
            display: 'true'
        }
    },
    {
        name: 'tiempo',
        label: 'Tiempo Respuesta',
        options: {
            filter: true,
            display: 'true'
        }
    },
    {
        name: 'estado',
        label: 'Estado',
        options: {
            filter: true,
            display: 'true'
        }
    },
    {
        name: 'revisadoEn',
        label: 'Revisado En',
        options: {
            filter: true,
            display: 'true',
            customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                const fecha = new Date(value);
                const tiempoFormateado = format(fecha, 'hh:mm:ss aa');
                return tiempoFormateado;
            }
        }
    },
    {
        name: 'mensaje',
        label: 'Observaciones',
        options: {
            filter: true,
            display: 'true',
        }
    }
];

// Colores para los estados
const red = '#F25050';
const ambar = '#F2930D';
const green = '#00A73B';

// Función para obtener el color según el estado y el tiempo
function codeWithButtonCopy(info: string, estado: string, tiempo: number) {
    const getColor = (estado: string) => {
        if (estado == 'Activo') {
            return tiempo <= 250 ? green : ambar;
        } else {
            return red;
        }
    };
    return <CopyInfo info={info} color={getColor(estado)} />;
}

export const ApisScreen: React.FC<{}> = ({ }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingTransporte, setIsLoadingTransporte] = useState(false);
    const { getEstadosApis, getEstadosApisTransporte } = useEstadosApis();
    const [dataApis, setDataApis] = useState<EstadoApi[]>([]);
    const [dataApisTransporte, setDataApisTransporte] = useState<EstadoApi[]>([])
    const today = new Date();
    const fetchEstadosApis = async () => {
        setIsLoading(true);
        const result = await getEstadosApis();
        if (result) {
            setDataApis(result);
        }
        setIsLoading(false);
    }
    const fetchEstadosApisTransporte = async () => {
        setIsLoadingTransporte(true);
        const result = await getEstadosApisTransporte();
        if (result) {
            setDataApisTransporte(result);
        }
        setIsLoadingTransporte(false);
    }
    const handleRefresh = () => {
        fetchEstadosApis();
        fetchEstadosApisTransporte();
    }
    //Recuperar datos
    useEffect(() => {
        fetchEstadosApis();
        fetchEstadosApisTransporte();
    }, [])

    //Modal de espera
    function openWaitModal(load: boolean) {
        dispatch(loadingModal(load));
    }

    useEffect(() => {
        openWaitModal(isLoading);
    }, [isLoading]);

    return (
        <>
            <TablaScreen columns={columns} data={dataApis} lastRevision={`${format(today, 'dd/MM/yy')} - ${format(today, 'hh:mm:ss aa')}`} onClick={handleRefresh} />

            <Grid container item margin={0} padding={0} xs={12} sx={{ padding: 0 }}>
                <Grid item xs={12}>
                    <Typography variant="h6" mt={0.5} textAlign="start" lineHeight={1.1}> APIs Transporte </Typography>
                </Grid>
                <Grid item xs={12} sx={isLoadingTransporte ? { display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' } : {}}>
                    {
                        isLoadingTransporte ? (
                            <>
                                <CircularProgress />
                                <Typography variant="h6" mt={0.5} textAlign="start" lineHeight={1.1}> Esta acción puede demorar unos minutos.</Typography>
                            </>
                        ) : (<MuiDataTable columns={columns} data={dataApisTransporte} />)
                    }
                </Grid>
            </Grid>
        </>
    )
}